<template>
  <div class="animated fadeIn">
    <!-- <div class="title font-300 font-24 mb-15">Form Weekly Log</div> -->
    <div class="box">
      <div class="p-20 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="
              openPage(
                '/memberData/detail?id=' +
                id_lead_member +
                '&id_lead=' +
                id_lead
              )
              " class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-20 pt-0">
        <form @submit.prevent="submitForm">
          <div class="row mb-30">
            <div class="col-lg-6">
              <div class="font-bold mt-20" style="font-size: 18px;">Basic Information</div>
              <hr class="short-line left" />
              <hr>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">Personal Trainer</div>
                </b-col>
                <b-col sm="9">
                  <b-form-select :disabled="true" name="refferal_pt_id" v-model="addData.personal_trainer_id"
                    class="form-control border-bottom">
                    <option value="null">Please select</option>
                    <option v-for="item in itemsPT" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>


              <br>
              <div class="font-bold mt-20" style="font-size: 18px;">Weekly Check In</div>
              <hr class="short-line left" />
              <hr>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">How many training sessions did you complete this week?<span
                      class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.how_many_training" id="how_many_training"
                    name="how_many_training">
                    <template v-for="value in HOW_MANY_TRAINING">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("how_many_training") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.how_many_training_remarks" name="how_many_training_remarks"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first("how_many_training_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">How consistent were you with your eating structure?<span
                      class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.how_consistent_eating_structure"
                    id="how_consistent_eating_structure" name="how_consistent_eating_structure">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("how_consistent_eating_structure") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.how_consistent_eating_structure_remarks"
                    name="how_consistent_eating_structure_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("how_consistent_eating_structure_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">How consistent were you with protein intake?<span class="text-danger">*</span>
                  </div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.how_consistent_protein_intake"
                    id="how_consistent_protein_intake" name="how_consistent_protein_intake">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("how_consistent_protein_intake") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.how_consistent_protein_intake_remarks" name="how_consistent_protein_intake_remarks"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first("how_consistent_protein_intake_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">How consistent were you with hydration?<span class="text-danger">*</span>
                  </div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.how_consistent_hydration"
                    id="how_consistent_hydration" name="how_consistent_hydration">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("how_consistent_hydration") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.how_consistent_hydration_remakrs" name="how_consistent_hydration_remakrs"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first("how_consistent_hydration_remakrs") }}</span>
                </b-col>
              </b-row>


              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">How was your sleep?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.how_your_sleep" id="how_your_sleep"
                    name="how_your_sleep">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("how_your_sleep") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.how_your_sleep_remarks" name="how_your_sleep_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("how_your_sleep_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">How was your energy?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.how_your_energy" id="how_your_energy"
                    name="how_your_energy">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("how_your_energy") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.how_your_energy_remarks" name="how_your_energy_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("how_your_energy_remarks") }}</span>
                </b-col>
              </b-row>


              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">How was your hunger / appetite control?<span class="text-danger">*</span>
                  </div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.how_appetite_control"
                    id="how_appetite_control" name="how_appetite_control">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("how_appetite_control") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.how_appetite_control_remarks" name="how_appetite_control_remarks"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first("how_appetite_control_remarks") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">How was your daily movement / walking?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.how_daily_walking" id="how_daily_walking"
                    name="how_daily_walking">
                    <template v-for="value in ONE_CHOICES">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("how_daily_walking") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.how_daily_walking_remarks" name="how_daily_walking_remarks" type="text"></b-form-input>
                  <span class="error">{{ errors.first("how_daily_walking_remarks") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>What went well this week?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.went_well_this_week" name="went_well_this_week" type="text"></b-form-input>
                  <span class="error">{{ errors.first("went_well_this_week") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Where did you lose structure?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.lose_structure" name="lose_structure" type="text"></b-form-input>
                  <span class="error">{{ errors.first("lose_structure") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div class="label-name">What obstacle challenged you most?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-radio-group v-validate="'required'" v-model="addData.obstacle_challenged"
                    id="obstacle_challenged" name="obstacle_challenged">
                    <template v-for="value in OBSTACLE_CHALLENGE">
                      <b-form-radio class="font-13" :value="value.id">{{ value.name }}</b-form-radio>
                    </template>
                  </b-form-radio-group>
                  <span class="error">{{ errors.first("obstacle_challenged") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Remarks</div>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="form-control border-bottom"
                    v-model="addData.obstacle_challenged_remarks" name="obstacle_challenged_remarks"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first("obstacle_challenged_remarks") }}</span>
                </b-col>
              </b-row>

              <!-- Remarks -->
              <b-row class="mb-20">
                <b-col sm="3">
                  <div>What is one standard you will improve next week?<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-input v-validate="'required'" class="form-control border-bottom"
                    v-model="addData.will_improve" name="will_improve" type="text"></b-form-input>
                  <span class="error">{{ errors.first("will_improve") }}</span>
                </b-col>
              </b-row>


            </div>

            <!-- Col 2 -->
            <div class="col-lg-6">
              <div class="font-bold mt-20" style="font-size: 18px;">Coach Notes</div>
              <hr class="short-line left" />
              <hr>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Main Win<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-textarea v-validate="'required'" id="main_win" name="main_win" v-model="addData.main_win"
                    placeholder="" rows="3" max-rows="6"></b-form-textarea>
                  <span class="error">{{ errors.first("main_win") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Main Issue<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-textarea v-validate="'required'" id="main_issue" name="main_issue"
                    v-model="addData.main_issue" placeholder="" rows="3" max-rows="6"></b-form-textarea>
                  <span class="error">{{ errors.first("main_issue") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Adjustment for next week<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-textarea v-validate="'required'" id="adjustment_next_week" name="adjustment_next_week"
                    v-model="addData.adjustment_next_week" placeholder="" rows="3" max-rows="6"></b-form-textarea>
                  <span class="error">{{ errors.first("adjustment_next_week") }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="3">
                  <div>Client commitment for next week<span class="text-danger">*</span></div>
                </b-col>
                <b-col sm="9">
                  <b-form-textarea v-validate="'required'" id="commitment_next_week" name="commitment_next_week"
                    v-model="addData.commitment_next_week" placeholder="" rows="3" max-rows="6"></b-form-textarea>
                  <span class="error">{{ errors.first("commitment_next_week") }}</span>
                </b-col>
              </b-row>

            </div>
          </div>
          <hr>
          <div class="text-right">
            <button type="submit" class="btn-primary">Submit</button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import { ModelSelect } from "vue-search-select";
import Mixin from '../../mixins/memberMixin'

export default {
  name: "addMemberDiary",
  components: {
    ModelSelect,
  },
  mixins: [Mixin],
  data: function () {
    return {
      loadingActive: false,
      itemsPT: [],
      optionsMember: [{ value: null, text: 'Please select' }],
      id_lead_member: null,
      id_lead: null,
      addData: {
        member_id: null,
        personal_trainer_id: null,
        how_many_training: null,
        how_many_training_remarks: '',
        how_consistent_eating_structure: null,
        how_consistent_eating_structure_remarks: '',
        how_consistent_protein_intake: null,
        how_consistent_protein_intake_remarks: '',
        how_consistent_hydration: null,
        how_consistent_hydration_remakrs: '', // typo mengikuti DB
        how_your_sleep: null,
        how_your_sleep_remarks: '',
        how_your_energy: null,
        how_your_energy_remarks: '',
        how_appetite_control: null,
        how_appetite_control_remarks: '',
        how_daily_walking: null,
        how_daily_walking_remarks: '',
        went_well_this_week: '',
        lose_structure: '',
        obstacle_challenged: null,
        obstacle_challenged_remarks: '',
        will_improve: '',
        main_win: '',
        main_issue: '',
        adjustment_next_week: '',
        commitment_next_week: '',
      },
      TIMEFRAME_EXPETATION: [],
      HOW_MANY_TRAINING: [],
      RATING_SCALE: [],
      ONE_CHOICES: [],
      MEAL_FREQUENCY: [],
      SNACKING_HABITS: [],
      WEEKEND_INTAKE: [],
      EATING_OUT_FREQ: [],
      WILLING_TO_TRACK: [],
      ORDINAL_SCALE: [],
      WORK_SCHEDULE: [],
      CONSISTENCY_LEVEL: [],
      OBSTACLE_CHALLENGE: [],
      visbodyPhotoPreview: null,
      visbodyPhotoPreview2: null,
      progressFrontPhotoPreview: null,
      progressSideLeftPhotoPreview: null,
      progressSideRightPhotoPreview: null,
    };
  },
  methods: {
    visbodyImagePreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.visbodyPhotoPreview = e.target.result;

          // for upload not base64
          this.visbodyPhotoPreview2 = input.files[0];

          this.onUploadImage();
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    frontPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressFrontPhotoPreview = input.files[0];

          this.onUploadImageProgress(1);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sideLeftPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressSideLeftPhotoPreview = input.files[0];

          this.onUploadImageProgress(2);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    sideRightPhotoPreview: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          console.log(e.target.result)
          // for upload not base64
          this.progressSideRightPhotoPreview = input.files[0];

          this.onUploadImageProgress(3);
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    openPage(event) {
      this.$router.push(event)
    },
    submitForm() {
      // console.log('this.addData', this.addData)
      this.$validator.validateAll().then((result) => {
        if (result) {
          // confirm
          this.$swal
            .fire({
              title: "Are you sure?",
              text: "You won't be able to revert this!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes, save it!",
            })
            .then((result) => {
              if (result.value) {
                this.loadingActive = true
                axios.put("crm/v1/assessment/weekly_log/" + this.$route.query.xid, this.addData)
                  .then((response) => {
                    console.log('response', response)
                    this.loadingActive = false
                    this.$swal.fire(
                      "Saved!",
                      "Data has been saved.",
                      "success"
                    );

                    this.reloadData();
                  }).catch(error => {
                    this.loadingActive = false
                    console.log('error', error)
                    this.$toast.success('cant saved data!', 'Error', {
                      position: 'topCenter',
                      icon: 'icon-envelope',
                      progressBarColor: 'rgb(0, 255, 184)',
                      theme: 'dark',
                      backgroundColor: '#565c70',
                      messageColor: '#fff'
                    })
                  })
              }
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff",
          });
        }
      });
    },
    onUploadImageProgress(event) {
      this.loadingActive = true
      const formDataS3 = new FormData();

      if (event == 1) {
        formDataS3.append("file", this.progressFrontPhotoPreview);
      } else if (event == 2) {
        formDataS3.append("file", this.progressSideLeftPhotoPreview);
      } else if (event == 3) {
        formDataS3.append("file", this.progressSideRightPhotoPreview);
      }

      formDataS3.append("prefix", `ASSESMENT-${this.$route.query.id}`);
      axios.post("https://digmsix.paradigmfitnessindonesia.com/s3/storage/upload", formDataS3)
        .then(resp => {
          console.log("Photo uploaded to s3", resp);
          let updateBody = {}

          if (event == 1) {
            updateBody = { progress_front_photo: resp.data.data.location }
          } else if (event == 2) {
            updateBody = { progress_side_left_photo: resp.data.data.location }
          } else if (event == 3) {
            updateBody = { progress_side_right_photo: resp.data.data.location }
          }
          // update to db
          axios.put(`crm/v1/assessment/first_assessment/${this.$route.query.xid}`, updateBody)
            .then(response => {
              this.loadingActive = false
              console.log("Photo updated", response);
              this.progressFrontPhotoPreview = null
              this.progressSideLeftPhotoPreview = null
              this.progressSideRightPhotoPreview = null
              this.reloadData()
            }).catch(error => {
              console.error("Photo error", error);
            })
        }).catch(error => {
          this.loadingActive = false
          console.error("Photo error", error);
        })
    },
    // visbody
    onUploadImage() {
      this.loadingActive = true
      const formDataS3 = new FormData();
      formDataS3.append("file", this.visbodyPhotoPreview2);
      formDataS3.append("prefix", `ASSESMENT-${this.$route.query.id}`);
      axios.post("https://digmsix.paradigmfitnessindonesia.com/s3/storage/upload", formDataS3)
        .then(resp => {
          console.log("Photo uploaded to s3", resp);
          // update to db
          axios.put(`crm/v1/assessment/first_assessment/${this.$route.query.xid}`, { visbody_photo: resp.data.data.location })
            .then(response => {
              this.loadingActive = false
              console.log("Photo updated", response);
              this.visbodyPhotoPreview2 = null
              this.reloadData()
            }).catch(error => {
              console.error("Photo error", error);
            })
        }).catch(error => {
          this.loadingActive = false
          console.error("Photo error", error);
        })
    },
    reloadData() {
      axios.get(`crm/v1/assessment/weekly_log/${this.$route.query.xid}`).then((response) => {
        this.addData = response.data.data;
      })
    },
    fetchData() {
      axios.get(`crm/v1/assessment/weekly_log/${this.$route.query.xid}`).then((response) => {
        this.addData = response.data.data;
      })

      axios.get("fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc").then((response) => {
        this.itemsPT = response.data.data.rows;
      })

      axios.get("crm/v1/assessment_category?page=&limit=").then((response) => {
        const data = response.data.data.rows;

        // filter timeframe expectation
        this.TIMEFRAME_EXPETATION = data.filter((item) => {
          return item.category_type == 'TIMEFRAME_EXPETATION';
        });

        this.HOW_MANY_TRAINING = data.filter((item) => {
          return item.category_type == 'HOW_MANY_TRAINING';
        });

        this.ONE_CHOICES = data.filter((item) => {
          return item.category_type == 'ONE_CHOICES';
        });

        // filter rating scale
        this.RATING_SCALE = data.filter((item) => {
          return item.category_type == 'RATING_SCALE';
        });

        // filter meal frequency
        this.MEAL_FREQUENCY = data.filter((item) => {
          return item.category_type == 'MEAL_FREQUENCY';
        });

        // filter snacking habits
        this.SNACKING_HABITS = data.filter((item) => {
          return item.category_type == 'SNACKING_HABITS';
        });

        // filter weekend intake
        this.WEEKEND_INTAKE = data.filter((item) => {
          return item.category_type == 'WEEKEND_INTAKE';
        });

        // filter eating out frequency
        this.EATING_OUT_FREQ = data.filter((item) => {
          return item.category_type == 'EATING_OUT_FREQ';
        });

        // filter willing to track
        this.WILLING_TO_TRACK = data.filter((item) => {
          return item.category_type == 'WILLING_TO_TRACK';
        });

        // filter ordinal scale
        this.ORDINAL_SCALE = data.filter((item) => {
          return item.category_type == 'ORDINAL_SCALE';
        });

        // filter work schedule
        this.OBSTACLE_CHALLENGE = data.filter((item) => {
          return item.category_type == 'OBSTACLE_CHALLENGE';
        });

        // filter consistency level
        this.CONSISTENCY_LEVEL = data.filter((item) => {
          return item.category_type == 'CONSISTENCY_LEVEL';
        });
      })
    },
  },
  created() {
    this.fetchData();
    this.id_lead_member = this.$route.query.id;
    this.addData.member_id = this.$route.query.id;
    this.id_lead = this.$route.query.id_lead;
  },
};
</script>

<style>
.upload-container {
  max-width: 700px;
}

.upload-box {
  display: block;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.upload-box:hover {
  border-color: #64748b;
  background: #f1f5f9;
}

.upload-content .icon {
  font-size: 40px;
  color: #94a3b8;
  margin-bottom: 10px;
}

.upload-content h5 {
  font-weight: 600;
  margin-bottom: 5px;
}

.upload-content p {
  color: #64748b;
  margin: 0;
}

.note {
  display: block;
  margin-top: 10px;
  color: #6b7280;
}


.required {
  color: red;
}

.radio-group {
  display: flex;
  gap: 20px;
  margin-top: 15px;
}

.radio-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

/* hide default radio */
.radio-item input {
  display: none;
}

.circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #64748b;
  transition: all 0.3s ease;
}

/* selected */
.radio-item input:checked+.circle {
  background: linear-gradient(135deg, #4f6df5, #3b5bdb);
  color: white;
  border: none;
}

/* label text */
.radio-item small {
  margin-top: 8px;
  color: #64748b;
}

.nutrition-note {
  max-width: 900px;
  color: #374151;
  font-family: 'Segoe UI', sans-serif;
}

.title-main {
  letter-spacing: 1px;
}

.section {
  margin-top: 30px;
}

.section-title {
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;
}

ol {
  padding-left: 20px;
  margin-bottom: 10px;
}

ol li {
  margin-bottom: 6px;
  letter-spacing: 0.5px;
}

.note {
  margin-top: 10px;
  color: #4b5563;
}
</style>
